import {EnkelGruppeModell, GruppeMedlemListeModell, InvitasjonSlettetRespons, Invitasjonsstatus, LitenIkkeTomStreng, MedlemId, TilgangsrolleMedlem} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {ChangeDetectionStrategy, Component, computed, Injectable, input, signal, TemplateRef, ViewChild} from "@angular/core";
import {AvatarKomponent} from "web-ng2/delt/komponenter/avatar/avatar";
import {KortHandlingerKomponent} from "web-ng2/delt/komponenter/kort/kort-handlinger/kort-handlinger";
import {MatButton, MatIconButton} from "@angular/material/button";
import {TranslateModule} from "@ngx-translate/core";
import {KortKomponent} from "web-ng2/delt/komponenter/kort/kort";
import {MatTooltip} from "@angular/material/tooltip";
import {BrukerkontekstTilbyder} from "felles-ng2/tjenester/BrukerkontekstTilbyder";
import {MatIcon} from "@angular/material/icon";
import {MedlemInvitasjonRedigerKomponent} from "web-ng2/moduler/medlem/komponenter/medlem-invitasjon-rediger/medlem-invitasjon-rediger";
import {FormaterMobilnummerPipe} from "felles-ng2/pipes/FormaterMobilnummerPipe";
import {navnFraMedlemModell} from "felles-ng2/modell/medlemModellHjelpere";
import {MatMenu, MatMenuItem, MatMenuTrigger} from "@angular/material/menu";
import {Bekreftelsesdialog} from "web-ng2/tjenester/Bekreftelsesdialog";
import {i18n, Oversettelser} from "felles-ng2/tjenester/i18n/Oversettelser";
import {GruppemedlemDatatjeneste} from "felles-ng2/tjenester/datalager/GruppemedlemDatatjeneste";
import {erIkkeNil, erNil} from "felles-ng2/støttefunksjoner/nilsjekk";
import {MeldingTilBruker} from "felles/tjenester/MeldingTilBruker";
import {InlineMeldingKomponent} from "web-ng2/delt/komponenter/inline-melding/inline-melding";
import {NavigasjonDeaktivering} from "web-ng2/tjenester/NavigasjonDeaktivering";
import {første} from "felles-ng2/støttefunksjoner/lister";
import {FormaterDatoPeriodeUtenTidPipe} from "felles-ng2/pipes/FormaterDatoPeriodeUtenTidPipe";

const debug = initDebugger('InvitasjonKortKomponent');

@Component({
    selector: 'medlem-invitasjon-kort',
    templateUrl: 'medlem-invitasjon-kort.html',
    styleUrl: 'medlem-invitasjon-kort.scss',
    host: { 'class': 'e2e-invitasjon' },
    imports: [
        MatTooltip,
        MatButton,
        MatIcon,
        TranslateModule,
        FormaterDatoPeriodeUtenTidPipe,
        KortKomponent,
        AvatarKomponent,
        KortHandlingerKomponent,
        MedlemInvitasjonRedigerKomponent,
        FormaterMobilnummerPipe,
        MatIconButton,
        MatMenu,
        MatMenuItem,
        MatMenuTrigger,
        InlineMeldingKomponent
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MedlemInvitasjonKortKomponent {

    @ViewChild('bekreftSlettDialogInnhold') private bekreftSlettDialogInnhold!: TemplateRef<any>;

    invitasjon = input.required<GruppeMedlemListeModell>();
    gruppe = input.required<EnkelGruppeModell>();

    statuser = Invitasjonsstatus;
    navn = computed(() => navnFraMedlemModell(this.invitasjon()));
    /** Rollen tildelt invitasjonen, merk at dette ikke nødvendigvis er en aktiv rolle, tar derfor den første rollen fra samlingen aktive+inaktive medlemsroller */
    rolle = computed(() => første([...this.invitasjon().aktiveMedlemsroller, ...this.invitasjon().inaktiveMedlemsroller]));
    redigeringMulig = computed(() => this.kontekst.autentisertBruker().inneharTilgangsrolleIGruppe(TilgangsrolleMedlem.skrive, this.gruppe().id));
    erRedigeringsmodus = signal(false);

    constructor(private avhengigheter: MedlemInvitasjonKortKomponentAvhengigheter, private navigasjonDeaktivering: NavigasjonDeaktivering, private kontekst: BrukerkontekstTilbyder, private meldingTilBruker: MeldingTilBruker, private bekreftelsesdialog: Bekreftelsesdialog, private oversettelser: Oversettelser) {
    }

    async slettEllerAnonymiser() {
        const årsak = await this.bekreftelsesdialog.visSlettMedÅrsak({
            tittel: this.oversettelser.oversett(i18n('Bekreft sletting av invitasjon')),
            htmlInnhold: this.bekreftSlettDialogInnhold,
            avbrytKnapp: this.oversettelser.oversett(i18n('Avbryt')),
            okKnapp: this.oversettelser.oversett(i18n('Ja, slett'))
        }).somPromise();
        if (erNil(årsak)) return;

        const respons = await this.avhengigheter.slettEllerAnonymiser(this.invitasjon().id, årsak);
        if (respons.slettet)
            this.meldingTilBruker.infomelding(this.oversettelser.oversett(i18n('Invitasjonen til {navn} har blitt slettet'), {navn: this.invitasjon().navn}));
        else
            this.meldingTilBruker.infomelding(this.oversettelser.oversett(i18n('Invitasjonen til {navn} har blitt permanent deaktivert'), {navn: this.invitasjon().navn}));
    }

    async sendInvitasjon() {
        await this.avhengigheter.sendInvitasjon(this.invitasjon().id);
        this.meldingTilBruker.infomelding(this.oversettelser.oversett(i18n('Invitasjon sendt til {navnEllerEpost} / {epost}'), {
            navnEllerEpost: this.invitasjon().navn,
            epost: this.invitasjon().epost
        }));
    }

    rediger() {
        this.navigasjonDeaktivering.deaktiverNavigasjon();
        this.erRedigeringsmodus.set(true);
    }

    vedRedigeringFerdig() {
        this.navigasjonDeaktivering.reaktiverNavigasjon();
        this.erRedigeringsmodus.set(false);
    }

    // private hjelpemetoder

}


@Injectable()
export class MedlemInvitasjonKortKomponentAvhengigheter {

    constructor(private gruppemedlemDatatjeneste: GruppemedlemDatatjeneste) {
    }

    async slettEllerAnonymiser(id: MedlemId, årsak: LitenIkkeTomStreng): Promise<InvitasjonSlettetRespons> {
        return this.gruppemedlemDatatjeneste.slettEllerAnonymiserInvitasjon(id, {aarsak: årsak});
    }

    async sendInvitasjon(id: MedlemId) {
        await this.gruppemedlemDatatjeneste.sendInvitasjon(id);
    }
}
